import styled from '@emotion/styled';

const TipBox = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid #D5D7DA;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 24px;
  align-items: center;
`;

export default TipBox;